export class Tab {
  constructor(
    public readonly key: string,
    public readonly url: string,
    public isSelected: boolean = false
  ) {}
}
